import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const initialState = {
  showLoader: false,
  showSteps: true,
  menuOpened: false,
  isStatusBarTransparent: getParameterFromURL('config') === 'short',
  initialAge: 'adult',
  initialRole: 'haveDog',
  promocode: null,
  forceLang: getParameterFromURL('force_lang'),
};

function steps(state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_LOADER':
      return {
        ...state,
        showLoader: action.payload,
      };

    case 'TOGGLE_STEPS':
      return {
        ...state,
        showSteps: action.payload,
      };

    case 'TOGGLE_MENU':
      return {
        ...state,
        menuOpened: action.payload,
      };

    case 'IS_STATUSBAR_TRANSPARENT':
      return {
        ...state,
        isStatusBarTransparent: action.payload,
      };

    case 'SET_PROMOCODE':
      return {
        ...state,
        promocode: action.payload,
      };

    case 'SET_AGE':
      return {
        ...state,
        initialAge: action.payload,
      };

    case 'SET_ROLE':
      return {
        ...state,
        initialRole: action.payload,
      };

    default:
      return state;
  }
}

export default steps;
